<div class="verifyHint" *ngIf="show">
  <ion-icon name="mail-outline" aria-hidden="true"></ion-icon>

  <div class="verifyHint__text">
    <strong>Bestätige deine E-Mail-Adresse.</strong>
    Wir haben dir einen Link geschickt. Dein Song ist trotzdem schon
    freigeschaltet.
  </div>

  <button type="button" class="verifyHint__action" [disabled]="sending" (click)="resend()">
    <ion-spinner *ngIf="sending" name="crescent"></ion-spinner>
    <span *ngIf="!sending">Erneut senden</span>
  </button>
</div>
